import React, { FC, HTMLProps } from 'react';
import styles from './small_text_button.module.scss';

type Props = HTMLProps<HTMLButtonElement>;

export const SmallTextButton: FC<Props> = ({ children, ...props }) => (
  <button className={styles.container} {...props} type="button">
    {children}
  </button>
);
